import { API_URL } from '../../../app-config/constants';
import { AutomationsOptionsDto, TargetGroup } from '../../react/features/Automations/types';
import { get } from '../request';

const BASE_URL = `${API_URL}/automations`;

getAutomationsOptions.operation = 'READ';
getAutomationsOptions.idFrom = 'ARGS';
export function getAutomationsOptions(params: { targetGroup: TargetGroup }): Promise<AutomationsOptionsDto> {
    return get<AutomationsOptionsDto>(`${BASE_URL}/options`, { getData: params });
}
